import o from "react";
import { useTranslation as v } from "react-i18next";
import { RssIcon as L } from "../../../../../common/components/Rss/Rss.js";
import { useAction as F } from "../../../../hooks/useAction.js";
import { useAuth as x } from "../../../../../auth/hooks/useAuth.js";
import { useWindowSize as H } from "../../../../../dom/hooks/useWindowSize.js";
import { ModalLinks as w } from "../../../../../common/components/ModalLinks/ModalLinks.js";
import { LandingButton as M } from "../../../LandingButton/LandingButton.js";
import { UserInitials as A } from "../UserInitials/UserInitials.js";
import t from "./userMenu.module.scss.js";
function W(h) {
  var _, C;
  const {
    showSeeProfileLink: k,
    sections: f = [],
    socials: s = [],
    onAccountClick: m,
    modalLinks: u,
    design: e = {
      generalHightlight: "#EA565C",
      hightLighHightlight: "#EA565C",
      accentColor: "#da81de",
      header: {
        textColor: "#FFF",
        primaryColor: "#242323"
      },
      content: {
        backgroundColor: "#FFF",
        textColor: "#242323",
        borderColor: "#dddddd"
      }
    },
    texts: r,
    utmReferral: d,
    navigationFn: E
  } = h, {
    customer: n,
    logout: p,
    login: b
  } = x(), {
    actionLinks: g
  } = F(
    [],
    f,
    {
      overrideHistory: !0,
      utmReferral: d
    },
    E
  ), { t: a } = v(), {
    isDesktop: y
  } = H(), N = (n == null ? void 0 : n.profile.firstName) || (r == null ? void 0 : r.guestLabel) || a("guest");
  return /* @__PURE__ */ o.createElement("div", { "data-testid": "user-menu", style: { color: (_ = e.header) == null ? void 0 : _.textColor }, className: t.menu }, /* @__PURE__ */ o.createElement("div", { style: { backgroundColor: (C = e.header) == null ? void 0 : C.primaryColor }, className: t.menu__header }, /* @__PURE__ */ o.createElement("div", { className: t.menu__user }, n && /* @__PURE__ */ o.createElement(
    A,
    {
      size: 60,
      fullName: n.profile.name,
      backgroundColor: (e == null ? void 0 : e.content.userProfileBackground) || (e == null ? void 0 : e.accentColor),
      textColor: e.header.textColor
    }
  ), /* @__PURE__ */ o.createElement("div", null, /* @__PURE__ */ o.createElement("div", { className: t.menu__user__name, "data-testid": "name" }, N), n === null && /* @__PURE__ */ o.createElement("div", { className: t.menu__user__login, onClick: () => b() }, (r == null ? void 0 : r.login) || a("loginText")), n && k && /* @__PURE__ */ o.createElement(
    "div",
    {
      className: t.menu__user__account,
      style: {
        color: e.hightLighHightlight
      },
      onClick: () => m == null ? void 0 : m()
    },
    a("userMenu.showProfile")
  )))), /* @__PURE__ */ o.createElement(
    "div",
    {
      style: {
        backgroundColor: e.content.backgroundColor,
        color: e.content.textColor
      },
      className: t.menu__content
    },
    g.length > 0 && /* @__PURE__ */ o.createElement("ul", { className: t.menu__content__linkList }, g.map(({ action: c, text: l }, i) => /* @__PURE__ */ o.createElement(
      "li",
      {
        key: `links_${i}`,
        style: {
          borderColor: e.content.borderColor
        }
      },
      /* @__PURE__ */ o.createElement(
        M,
        {
          action: c,
          className: t.menu__content__linkButton,
          backgroundColor: e.content.backgroundColor,
          textColor: e.content.textColor,
          utmReferral: d
        },
        l
      )
    ))),
    s.length > 0 && /* @__PURE__ */ o.createElement("ul", { className: t.menu__content__linkList }, /* @__PURE__ */ o.createElement(
      "li",
      {
        style: {
          borderColor: e.content.borderColor
        }
      },
      s.map(({ url: c, img: l, rss: i }) => /* @__PURE__ */ o.createElement("a", { href: c, key: `${i}_${c}` }, l && /* @__PURE__ */ o.createElement("img", { src: l, alt: "social-icon" }), !l && /* @__PURE__ */ o.createElement(
        L,
        {
          rss: i,
          height: 30,
          width: 30,
          fill: e.generalHightlight
        }
      )))
    )),
    n && /* @__PURE__ */ o.createElement(
      "div",
      {
        onClick: () => p(),
        className: t.menu__content__action,
        style: { color: e.generalHightlight }
      },
      (r == null ? void 0 : r.logout) || a("userMenu.logout")
    ),
    !y && u && /* @__PURE__ */ o.createElement(
      w,
      {
        links: u,
        design: {
          color: e.content.textColor || "",
          backgroundColor: e.content.backgroundColor || ""
        }
      }
    )
  ));
}
export {
  W as UserMenu
};
//# sourceMappingURL=UserMenu.js.map
